import { MediaAcademyResourceCategory } from './typings'


export const mediaAcademyResouceCategoryLabels: Record<MediaAcademyResourceCategory, string> = {
  PLAYBOOK: 'Playbook',
  WHITEPAPER: 'Whitepaper',
}


export const isS3ImageUrl = (url: string): boolean => (
  url.includes('vf-custom-data-percept.s3.amazonaws.com')
)
